/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import { Layout, Drawer, Affix } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import {Breadcrumb, Button, Col, Divider, PageHeader, Row} from 'antd';
import {
  DotChartOutlined, 
  MenuFoldOutlined, 
  MenuUnfoldOutlined,
  LeftCircleOutlined,
  RightCircleOutlined,
  MenuOutlined
} from '@ant-design/icons';
import {useLocation, Link, useNavigate} from "react-router-dom";
import TheHeaderDropdown from "../../containers/TheHeaderDropdown";
import routes from "../../routes";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [sidenavType, setSidenavType] = useState("white");
  const [fixed, setFixed] = useState(false);

  // const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const openDrawer = () => setVisible(!visible);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");


  function isRtl() {
    console.log(pathname);
    return true;
  }

  useEffect(() => {
    setPlacement("right");
  }, [pathname]);

  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    const routeelement = routes[1].routes.find((element) => {
        return element.path === url
    });
    
    return (<Breadcrumb.Item key={'bci' + url}>
        <Link key={'bcl' + url} to={url}>{routeelement.name}</Link>
    </Breadcrumb.Item>);
  });
  const breadcrumbItems = [<Breadcrumb.Item key="bcihome">
      <Link key='bredcsadgan' to="/">پایش فضای شناختی</Link>
  </Breadcrumb.Item>,].concat(extraBreadcrumbItems);




  // console.log("placement", placement);
  const [collapsed, setCollapsed] = useState(true);
  const [visibility, setVisibility] = useState(false);
  return (
    <Layout
      className={`layout-dashboard ${
        pathname === "profile" ? "layout-profile" : ""
      } ${isRtl() ? "layout-dashboard-rtl" : ""}`}
    >
      {/* <div>
       <PageHeader
            key={'pageheader1'}
            ghost={false}
            // title='پایش فضای شناختی'
            title=''
            subTitle={[
                <DotChartOutlined style={{ fontSize: '32px', color: '#08c', margin: "0 3px 0 5px"}}/>,
                <Breadcrumb key={'pageheaderfooter'} style={{ display: 'inline-flex' }}>
                  {breadcrumbItems}
                </Breadcrumb>,
                <div>
                  <span style={{
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#d9dcdf'
                  }}>
                  سامانه برآورد فضای هندسی نگرش/باور ها
                  </span>
                </div>,
                 
            ]}

            extra={[<TheHeaderDropdown key='TheHeaderDropdown'/>]}
            // 
            style={{
                paddingBottom: '10px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                // marginBottom: '10px',
                // backgroundColor: 'unset'
            }}
        >
        </PageHeader>
      </div> */}
      <div>

      <Layout className="content-layout" style={{marginRight: 0}}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
        trigger={null}
        width={'auto'}
        // theme="light"
        className={`sider-primary ant-layout-sider-primary ${
          sidenavType === "#fff" ? "active-route" : ""
        }`}
        style={{ 
          // background: sidenavType 
          // backgroundColor: '#1c2b36',
          // color: '#fff',
          // flex: 'unset',
          maxWidth: '300px',
          position: 'relative',
        }}
      >

        <Button
          // type="primary"
          onClick={toggleCollapsed}
          shape="circle"
          type="text"
          style={{
            marginBottom: '16px',
            // paddingTop: '3px',
            // position: 'absolute', 
            // bottom: 60,
            color: '#1F6E8C',
            marginTop: '30px',
            verticalAlign: 'middle',
            margin: '0 10px 16px 10px',
            padding: '0 3px',
          }}
        >
          <MenuOutlined style={{fontSize: '18px'}}/> 
          {/* {collapsed && <span style={{fontSize: '12px', fontWeight:300}}>سامانه برآورد فضای هندسی نگرش/باور ها</span>} */}
          {/* {collapsed ? <MenuUnfoldOutlined style={{fontSize:"18px"}}/> : <MenuFoldOutlined style={{fontSize:"18px"}}/>} */}
          {/* {collapsed ? <LeftCircleOutlined /> : <RightCircleOutlined />} */}
        </Button>


        <Sidenav color={sidenavColor} collapsed={collapsed}/>

        
      </Sider>
      
        <Content className="content-ant">{children}</Content>
        {/* <Footer /> */}
      </Layout>
      </div>
    </Layout>
  );
}

export default Main;
